//
//
//
//
//
//
//

export default {
  props: {
    title: {
      default: ""
    },
    icon: {
      default: null
    }
  },
  computed: {
    selections() {
      return this.$store.state.betslip.selections
    }


  }
}
